import { documentTemplateQuery } from "@common/api/document-templates"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { isDocumentKind, KIND_LABELS } from "../-lib/kinds"
import { TemplateForm } from "./-components/form/template-form"
import { templateSearchSchema } from "./-lib/search"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/templates/$kind",
)({
  validateSearch: (search) => templateSearchSchema.parse(search),
  beforeLoad: ({ params }) => {
    if (!isDocumentKind(params.kind)) {
      throw redirect({ to: "/settings/workspace/templates" })
    }
    return { kind: params.kind }
  },
  loader: async ({ context: { queryClient, kind } }) => {
    await queryClient.ensureQueryData(documentTemplateQuery(kind))
    return { breadcrumb: KIND_LABELS[kind] }
  },
  component: TemplatePage,
})

function TemplatePage(): React.ReactElement {
  const { kind } = Route.useRouteContext()
  const { data: template } = useSuspenseQuery(documentTemplateQuery(kind))
  const showToast = useCustomToast()

  return (
    <>
      <TemplateForm
        key={`${template.kind}-${template.is_default}`}
        template={template}
        onSave={() =>
          showToast("Saved", `${KIND_LABELS[kind]} template saved.`, "success")
        }
      />
      <Outlet />
    </>
  )
}
